import { left, right } from 'fp-ts/Either';
import { OfficeCountry, OfficeLanguage } from '../../../../hexagon/config/appConfig';
import { UserDataGateway } from '../../../../hexagon/gateways/userDataGateway.interface';
import { ApiResponse } from '../../../../hexagon/infra/ApiResponse';
import { UserFeeds } from '../../../../hexagon/models/userFeedsModel';
import { UserStats } from '../../../../hexagon/models/userStatsModel';
import { Banner } from '../../../../hexagon/models/BannerModel';
import { Popup } from '../../../../hexagon/models/PopupModel';

import { UpdatableUserAlcopaCredential } from '../../../../hexagon/models/userModel';

export class InMemoryUserDataGateway implements UserDataGateway {
    private userFeeds = {} as UserFeeds;

    private userStats = {} as UserStats;

    private banner = {} as Banner;

    private popup = {} as Popup;

    setToken(token: string): ApiResponse<boolean> {
        if (token) {
            return right(true);
        }

        return left({ code: '401', message: 'not authorized' });
    }

    getUserFeeds(language: OfficeLanguage): Promise<ApiResponse<UserFeeds>> {
        if (this.userFeeds && language) {
            this.userFeeds.totalFeeds = Math.ceil(Math.random() * 100);
            return Promise.resolve(right(this.userFeeds));
        }
        return Promise.resolve(left({ code: 'error_code', message: 'error_message' }));
    }

    getUserStats(): Promise<ApiResponse<UserStats>> {
        if (this.userStats) {
            return Promise.resolve(right(this.userStats));
        }
        return Promise.resolve(left(this.userStats));
    }

    feedUserFeedsWith(userFeeds?: UserFeeds) {
        if (userFeeds) this.userFeeds = userFeeds;
    }

    feedUserStatsWith(userStats?: UserStats) {
        if (userStats) this.userStats = userStats;
    }

    updateUserAlcopa(userInfo: UpdatableUserAlcopaCredential): Promise<ApiResponse<boolean>> {
        if (userInfo) {
            return Promise.resolve(right(true));
        }
        return Promise.resolve(right(false));
    }

    feedBannerWith(banner?: Banner) {
        if (banner) this.banner = banner;
    }

    feedPopupWith(popup?: Popup) {
        if (popup) this.popup = popup;
    }

    getBanner(language: OfficeLanguage, country: OfficeCountry): Promise<ApiResponse<Banner>> {
        if (this.banner && country && language) {
            return Promise.resolve(right(this.banner));
        }
        return Promise.resolve(left({ code: 'error_code', message: 'error_message' }));
    }

    getPopup(language: OfficeLanguage, country: OfficeCountry): Promise<ApiResponse<Popup>> {
        if (this.popup && country && language) {
            return Promise.resolve(right(this.popup));
        }
        return Promise.resolve(left({ code: 'error_code', message: 'error_message' }));
    }
}
